'use strict';
export const PATH_LOGIN = "login";
export const PATH_FORGOT_PASSWORD = "forgot-password";
export const PATH_CONFIG_SERVER = "config-server";

// side nav items
export const PATH_TOP_AGENTS = "topAgents";
export const PATH_AGENTS_WITH_ALERT = "agentWithAlerts";
export const PATH_AGENTS_WITH_PERFORMANCE = "agentWithPerformance";
export const PATH_AGENTS_UNDER_PLAN = "agentUnderPlan";
export const PATH_SEARCH = "search";
export const PATH_PERSONS = "persons";
export const PATH_NEWS = "news";
export const PATH_RECENT_RPOFILES = "recentProfiles";
export const PATH_SETTING = "setting";
export const PATH_FOLLOWING = "following";
export const PATH_NOTIFICATIONS = "notifications";

// entity detail
export const PATH_AGENT_DETAIL = "agentDetail";
export const PATH_PERSON_DETAIL = "personDetail";
export const PATH_AGENT_CONTACT_DETAIL = "contactDetail";
export const PATH_AGENT_OBJECTIVE = "agentObjective";
export const PATH_NOTES = "notes";
export const PATH_THIRTEEN_MONTH_ACTIVITY = "thirteenMonthActivity";
export const PATH_AGENT_ASSOCIATES = "agentAssociates";
export const PATH_PERSON_AGENTS = "personAgents";
export const PATH_OPEN_ALERTS = "openAlerts";
export const PATH_OPEN_ALERT_DETAIL = "openAlertDetail";
export const PATH_CLAIMS = "claims";
export const PATH_CLAIM_DETAIL = "claimDetail";
export const PATH_AGENT_AUDITS = "agentAudits";
export const PATH_AGENT_JOURNALS = "agentJournals";
export const PATH_AGENT_AUDIT_QUEUED = "agentAuditQueued";
export const PATH_AGENT_AUDIT_COMPLETED = "agentAuditCompleted";
export const PATH_AGENT_COMPLIANCE = "agentCompliance";
export const PATH_COMPLIANCE_DETAIL = "complianceDetail";
export const PATH_VIEW_SENTIMENT_HISTORY = "sentimentHistory";

export const PATH_AGENT_TAGS = "agentTags";
export const PATH_ASSOCIATED_AGENTS = "associatedAgents";
export const PATH_EVENTS = "events";
// others
export const PATH_REARRANGE_DRAWER_ITEM = "rearrangeHomeModules";
export const PATH_REARRANGE_AGENT_DETAIL_ITEM = "rearrangeAgentDetailModules";
export const PATH_NOTIFICATION_CONTROL = "notificationControls";
export const PATH_REARRANGE_PERSON_DETAIL_ITEM = "rearrangePersonModules";

// add side navigation path for hanlde back navigation
export const sideNavRoutePaths = [PATH_TOP_AGENTS, PATH_AGENTS_WITH_ALERT, PATH_AGENTS_WITH_PERFORMANCE, PATH_SEARCH, PATH_NEWS, PATH_SETTING, PATH_RECENT_RPOFILES, PATH_AGENTS_UNDER_PLAN, PATH_SETTING, PATH_NOTIFICATIONS];


